module.exports = __webpack_public_path__ + "assets/img/2221591947409_.pic.9cfda659.jpg";